import { dispatch } from '../../dispatcher';
import { ActionTypes } from '../../constants/MogamboConstants';
import { GOOGLE_ANALYTICS } from '../../const';
import { sendGoogleAnalyticsEvents } from '../_utils';

export function openComponentTooltip(
  position,
  children,
  type,
  destinationRect
) {
  dispatch(ActionTypes.OPEN_COMPONENT_TOOLTIP, {
    position,
    children,
    type,
    destinationRect,
  });
  sendGoogleAnalyticsEvents(
    GOOGLE_ANALYTICS.CATEGORY.TOOLTIP,
    GOOGLE_ANALYTICS.EVENTS.TOOLTIP_CLICKED,
    GOOGLE_ANALYTICS.LABEL.TOOLTIP_OPEN,
    GOOGLE_ANALYTICS.VALUE.SINGLE_CLICK
  );
}

export function closeComponentTooltip() {
  dispatch(ActionTypes.CLOSE_COMPONENT_TOOLTIP);
}
